import React from 'react';
import { Card } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const VocabularyRoleActionsCard = ({ vocabulary }) => (
  <Card.Description>
    <FormattedMessage id="items.count" values={{ count: vocabulary.roleActions.length }} />
  </Card.Description>
);

export default VocabularyRoleActionsCard;
